import { callApi } from '@/api/api-core'

export const payAnonymousDibs = function(orderId, transactionId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId,
		transactionId: transactionId
	}

	return callApi('POST', 'v2/payment/dibs/pay/anonymous', requestData, ownerHandlesFailure)
}

export const payAnonymousEpay = function(orderId, transactionId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId,
		transactionId: transactionId
	}

	return callApi('POST', 'v1/payment/epay/pay/anonymous', requestData, ownerHandlesFailure)
}

export const payAnonymousDeveloper = function(orderId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId
	}

	return callApi('POST', 'v2/payment/developer/pay/anonymous', requestData, ownerHandlesFailure)
}

export const payAnonymousFree = function(orderId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId
	}

	return callApi('POST', 'v1/payment/free/pay/accountlesscustomer', requestData, ownerHandlesFailure)
}

export const initEpayPayment = function(orderId, ownerHandlesFailure) {
	return callApi('POST', 'v2/payment/epay/init', { orderId }, ownerHandlesFailure)
}

export const exchangeDownloadTokenDeveloper = function(orderId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId
	}

	return callApi('POST', 'v2/payment/developer/exchange/downloadtoken', requestData, ownerHandlesFailure)
}

export const exchangeDownloadTokenFree = function(orderId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId
	}

	return callApi('POST', 'v1/payment/free/exchange/downloadtoken', requestData, ownerHandlesFailure)
}

export const exchangeDownloadTokenDibs = function(orderId, transactionId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId,
		transactionId: transactionId
	}

	return callApi('POST', 'v2/payment/dibs/exchange/downloadtoken', requestData, ownerHandlesFailure)
}

export const exchangeDownloadTokenEpay = function(orderId, transactionId, ownerHandlesFailure) {
	const requestData = {
		orderId: orderId,
		transactionId: transactionId
	}

	return callApi('POST', 'v1/payment/epay/exchange/downloadtoken', requestData, ownerHandlesFailure)
}

export const initNetaxept = function(orderId, redirectUrl, language, ownerHandlesFailure) {
	const requestData = {
		orderId,
		redirectUrl,
		language
	}

	return callApi('POST', 'v1/payment/netaxept/payment/init/webshop', requestData, ownerHandlesFailure)
}

export const finalizeNetaxept = function(orderId, transactionId, ownerHandlesFailure) {
	const requestData = {
		orderId,
		transactionId
	}

	return callApi('POST', 'v2/payment/netaxept/payment/finalize/webshop', requestData, ownerHandlesFailure)
}

export const initializeDibsEasy = function(orderId, returnUrl, ownerHandlesFailure) {
	const requestData = {
		orderId,
		returnUrl
	}

	return callApi('POST', 'v2/payment/easy/payment/initialize', requestData, ownerHandlesFailure)
}

export const finalizeDibsEasy = function(paymentId, orderId, ownerHandlesFailure) {
	const requestData = {
		paymentId,
		orderId
	}

	return callApi('POST', 'v2/payment/easy/payment/finalize', requestData, ownerHandlesFailure)
}

export const initializeMobilePay = function(orderId, ownerHandlesFailure) {
	// overridingPaymentMethod can be "Card" or "Wallet"
	const requestData = {
		orderId
	}

	return callApi('POST', 'v1/payment/mobilepay/init', requestData, ownerHandlesFailure)
}

export const finalizeMobilePay = function(paymentId, orderId, ownerHandlesFailure) {
	const requestData = {
		paymentId,
		orderId
	}

	return callApi('POST', 'v1/payment/mobilepay/pay', requestData, ownerHandlesFailure)
}

export const mobilePayStatus = function(orderId, ownerHandlesFailure) {
	const requestData = {
		orderId
	}

	return callApi('POST', 'v1/payment/mobilepay/lookup', requestData, ownerHandlesFailure)
}

export const refund = function(orderId, email, name, address, zip, city, ownerHandlesFailure) {
	const requestData = {
		orderId,
		email,
		name,
		address,
		zip,
		city
	}

	return callApi('POST', 'v1/payment/refund/webshop', requestData, ownerHandlesFailure)
}
